import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {LineBotService} from "../../_services/line-bot.service";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {DataTableDirective} from "angular-datatables";
import {DialogService} from "ng2-bootstrap-modal";
import {PopupSettingSendSignalComponent} from "./popup-setting-send-signal/popup-setting-send-signal.component";
import {SendSignalService} from "../../_services/send-signal.service";
import * as moment from 'moment-timezone';
import {AppConfigs} from "../../app.config";

@Component({
    selector: 'app-event-send-signal',
    templateUrl: './send-signal-event.component.html',
    styleUrls: ['./send-signal-event.component.css'],
    encapsulation: ViewEncapsulation.None,

})
export class SendSignalEventComponent implements OnInit {

    delayTimer: any;
    lineBotAlls: Observable<any[]>;
    dtTrigger: Subject<any> = new Subject();
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    objPopUp: any;
    eventName: string;
    line_bot_id: string;
    parameters: any = {};

    //declare callback object
    callback: any = {};
    /**
     * filterBy = 1; // load all events not Active
     * filterBy = 0; // load active events Active
     * filterBy = 2; // load all events
     */
    filterBy = 2; // default load all in Bot
    constantSendSignal: any;

    constructor(private dialogService: DialogService,
                private sendSignalService: SendSignalService,
                private lineBotService: LineBotService,
    ) {
        this.constantSendSignal = this.sendSignalService.getConstantSendSignal();
    }

    ngOnInit() {
        let self = this;
        this.lineBotAlls = this.lineBotService.getLineBot();
        self.sendSignalTable(this.lineBotAlls);
    }

    sendSignalTable(lineBotAll: any) {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[3, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.eventName || '';
                parameters["search"]["is_active"] = self.filterBy;

                lineBotAll.subscribe(dataLineBot => {
                    parameters["search"]["line_bot_id"] = self.line_bot_id || dataLineBot[0].id;
                    //assign parameters object
                    self.parameters = parameters;
                    //assign callback object
                    self.callback = callback;

                    self.sendSignalService.getEventSendSignal(parameters).subscribe(result => {
                        callback({
                            draw: parameters['draw'],
                            data: result.data,
                            recordsTotal: result.data.length,
                            recordsFiltered: result.recordsTotal
                        });
                    });
                });
            },
            columns: [
                {
                    title: "イベント名",
                    name: "event_name",
                    className: "all text-justify elementEventName",
                    width: '6%',
                    data: 'event_name'
                },
                {
                    title: "配信時刻",
                    data: function (item) {
                        return item.send_time ? moment(item.send_time).format('YYYY-MM-DD HH:mm') : '';
                    },
                    name: "send_time",
                    className: "all text-justify"
                },
                {
                    title: "ステータス",
                    data: 'status',
                    name: "status",
                    className: "all text-justify",
                    orderable: false
                },
                {
                    title: "作成先",
                    data: "created_at",
                    name: "created_at",
                    className: "all text-justify"
                },
                {
                    title: "更新先",
                    data: "updated_at",
                    name: "updated_at",
                    className: "all text-justify"
                },
                {
                    data: function (d) {
                        return `<button class="btn btn-sm btn-edit">編集</button>`;
                    },
                    width: '120px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    width: '120px',
                    title: "アカウント設定",
                    data: "btn_block",
                    className: "all text-center",
                    orderable: false
                },
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                $('.btn-edit', row).bind('click', () => {
                    self.openModalSettingSendSignal(data);
                });

                $('.btn-set-bot', row).bind('click', () => {
                    data['line_bot_id'] = this.parameters["search"]["lineBot"];
                    self.setSendSignalActive(data);
                });

                var btn_edit = $(row).find('td').find('.btn-edit');
                btn_edit.css({
                    'background-color': 'deepskyblue',
                    'color': '#fff'
                });
                btn_edit.mouseover(function () {
                    btn_edit.css('opacity', '0.9');
                });
                btn_edit.mouseout(function () {
                    btn_edit.css('opacity', '1');
                });

                let clientWidth = document.documentElement.clientWidth;
                let maxWidth = clientWidth < 850
                    ? 20
                    : (clientWidth > 850 && clientWidth < 1200)
                        ? 100
                        : (clientWidth > 1200 && clientWidth < 1500)
                            ? 250
                            : (clientWidth > 1500 && clientWidth < 1700)
                                ? 300
                                : 350;
                var td_row = $(row).find('td.elementEventName');
                td_row.css({
                    'word-wrap': 'break-word',
                    'max-width': maxWidth + 'px',
                    'white-space': 'nowrap',
                    'overflow': 'hidden',
                    'text-overflow': 'ellipsis'
                });

                if (data['is_active'] == 1) {
                    $(row).css('background-color', '#3c8dbc');

                    var btn_active_bot = $(row).find('td:last').find('.btn-active-bot');
                    btn_active_bot.css({
                        'background-color': 'HotPink',
                        'border-color': 'HotPink'
                    });
                    btn_active_bot.mouseover(function () {
                        btn_active_bot.css('opacity', '0.8');
                    });
                    btn_active_bot.mouseout(function () {
                        btn_active_bot.css('opacity', '1');
                    });
                }
                return row;
            }
        };
    }

    setSendSignalActive(data) {
        let self = this;
        this.sendSignalService.setSendSignalActive(data).subscribe(data => {
            if (!data.error) {
                self.loadCurrentPage();
            } else {
                alert(data.message);
            }
        }, error => {
            alert(error.json().message);
        });
    }

    openModalSettingSendSignal(dataObject: any) {
        let self = this;
        this.constantSendSignal.subscribe(constantSendSignal => {
            let listCoinID = dataObject ? dataObject.list_coin_id : null;
            let lineBotID = dataObject ? dataObject.line_bot_id : $('#line-bot :selected').val();
            this.sendSignalService
                .postListCoinActive({
                    listCoinID: listCoinID
                })
                .subscribe((resCoinList: Response) => {
                    if (Object.keys(resCoinList).length) {
                        self.objPopUp = {
                            constantSendSignal: constantSendSignal.constants,
                            data: dataObject,
                            titlePopup: 'シグナル配信の設定' + (dataObject ? '（編集）' : '（追加）'),
                            listCoinSendSignal: resCoinList,
                            btnSaveOrUpdate: (dataObject ? '更新' : '保存'),
                            sendSignalEventID: dataObject ? dataObject.id : null,
                            lineBotID: lineBotID
                        };

                        this.dialogService.addDialog(PopupSettingSendSignalComponent, self.objPopUp).subscribe((isAccess) => {
                            if (isAccess) {
                                this.loadCurrentPage();
                            }
                        });
                    }
                });
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page
        this.sendSignalService.getEventSendSignal(this.parameters).subscribe(result => {
            this.callback({
                draw: this.parameters['draw'],
                data: result.data,
                recordsTotal: result.data.length,
                recordsFiltered: result.recordsTotal
            });
        });
    }

    onChangeLineBot(event) {
        this.line_bot_id = event.target.value;
        this.renderDataTable();
    }

    renderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    valueChange(newValue) {
        this.eventName = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.renderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    onChangeFilter(value) {
        this.filterBy = value;
        this.renderDataTable();
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/send-signal-event/send-signal-event.component.ts